import React from 'react'
import PropTypes from 'prop-types'
import { createMarkup } from '../../../../../utils/Helper'
import { Box } from '@material-ui/core'

const HtmlColumn = ({ object, height }) => (
  <Box
    component={'div'}
    className={' position-wrapper'}
    height={height}
    overflow="scroll"
    dangerouslySetInnerHTML={createMarkup(object.editorState)}
  />
)

HtmlColumn.propTypes = {
  object: PropTypes.object,
  height: PropTypes.number,
}

export default HtmlColumn
